<template>
  <div v-if="!disabled" class="form-floating" :class="'mb-'+mb">
    <input
        class="form-control form-control-solid"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :value="modelValue"
        :required="required"
        :name="name"
        :max="max"
        :min="min"
        type="date"
        :id="id"
        @input="updateValue"
        readonly="readonly"
    >
    <label :for="id" :class="{ required: required }" v-html="placeholder"></label>
    <slot></slot>
  </div>
  <disabled-field v-else :value="dateFormat" :mb="mb" :placeholder="placeholder" :required="required"/>
</template>

<script>
import DisabledField from '@/components/Fields/DisabledField'
import moment from "moment/moment";

export default {
  name: 'DateField',
  components: {DisabledField},
  props: {
    placeholder: null,
    modelValue: '',
    required: false,
    disabled: false,
    readonly: false,
    class: null,
    name: null,
    max: '',
    min: '',
    mb:null,
    id:null
  },
  computed: {
    dateFormat() {
      if (this.modelValue) {
        // Если уже в формате DD.MM.YYYY, не парсим через moment
        if (/^\d{2}\.\d{2}\.\d{4}$/.test(this.modelValue)) {
          return this.modelValue;
        }
        return moment(this.modelValue).locale('ru').format("DD.MM.YYYY");
      }
    }
  },
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.target.value)
    }
  }
}
</script>

<style scoped>

</style>